const APPLICATIONS_LIST_PAGE_KEY = 'applicationsListPage'
const APPLICATIONS_LIST_PAGE_SIZE_KEY = 'applicationsListPageSize'

const parseStoredNumber = (value: string | null): number | null => {
    if (value === null || !/^\d+$/.test(value)) {
        return null
    }

    return Number(value)
}

export const getStoredApplicationsListPage = (): number | null =>
    parseStoredNumber(window.localStorage.getItem(APPLICATIONS_LIST_PAGE_KEY))

export const setStoredApplicationsListPage = (page: number) => {
    window.localStorage.setItem(APPLICATIONS_LIST_PAGE_KEY, page.toString())
}

export const getStoredApplicationsListPageSize = (): number | null =>
    parseStoredNumber(
        window.localStorage.getItem(APPLICATIONS_LIST_PAGE_SIZE_KEY),
    )

export const setStoredApplicationsListPageSize = (pageSize: number) => {
    window.localStorage.setItem(
        APPLICATIONS_LIST_PAGE_SIZE_KEY,
        pageSize.toString(),
    )
}

export const clearStoredApplicationsListPagination = () => {
    window.localStorage.removeItem(APPLICATIONS_LIST_PAGE_KEY)
    window.localStorage.removeItem(APPLICATIONS_LIST_PAGE_SIZE_KEY)
}
